var map = {
	"./Cook.png": "5741",
	"./Cool.png": "2ece",
	"./Cry.png": "7233",
	"./Eat.png": "45e1",
	"./How are you.png": "bc21",
	"./I made it.png": "08f3",
	"./Im going there.png": "fe38",
	"./Laughs.png": "c217",
	"./Love.png": "17c1",
	"./Ooops.png": "6ba7",
	"./Plant a plant.png": "31b1",
	"./Sad.png": "3848",
	"./Send me a ticket.png": "78fb",
	"./Shy.png": "538a",
	"./Sleep.png": "dc17",
	"./Thank you.png": "b91f",
	"./Ticket.png": "5a9c",
	"./What.png": "9ca9",
	"./go.png": "3c54",
	"./help.png": "596f",
	"./hope.png": "6cae",
	"./ok.png": "6671",
	"./welcome.png": "e8dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed28";